<template>
  <div class="checkbox">
    <input
      :checked="checked"
      :disabled="disabled"
      :id="name"
      :name="name"
      class="input"
      type="checkbox"
      @change="onChange($event, name)"
    />
    <label class="indicator" :for="name"></label>
    <label class="checkbox__label" :for="name">
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  name: 'AfCheckbox',

  props: {
    name: String,
    label: String,
    checked: Boolean,
    disabled: Boolean
  },

  methods: {
    onChange(event, name) {
      this.$emit('changed', name, event.target.checked)
    }
  }
}
</script>

<style lang="postcss" scoped>
@import 'variables/custom-media.css';

.checkbox {
  align-items: center;
  display: flex;
}

.checkbox__label {
  flex: 1;
}

.input {
  display: none;
}

.indicator {
  background-color: #fff;
  border: 1px solid var(--color-mine-shaft);
  border-radius: 3px;
  cursor: pointer;
  display: block;
  height: 14px;
  margin-right: var(--spacing-third);
  position: relative;
  width: 14px;
  z-index: 1;
}

.input:checked + .indicator:before {
  content: '\f00c';
  font-family: 'FontAwesome';
  font-size: 12px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);

  @media (--ie11) {
    content: url('./../../static/icons/check.svg');
    height: 12px;
    width: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AfCheckbox.vue